var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('os-sheet',{staticClass:"minimal-critical-height"},[_c('os-target-profile-form',{attrs:{"campaign-id":_vm.internalCampaignId,"show-campaign-lookup":_vm.showCampaignLookup,"title":_vm.$tc('form.target_profile.title')},on:{"recordDeleted":() => _vm.recordDeleted()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }